import React, { useContext, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router';
import { ConfirmContext } from '../../components/ConfirmModal';
import axios from 'axios';
import { API_URL } from '../../../config/constants';
import createIconImg from '../../../images/createIcon.png';
import editDSIcon from '../../../images/editDS.png';
import deleteDSIcon from '../../../images/deleteDS.png';
import { useSelector } from 'react-redux';
import CustomCheckbox from '../../components/CustomCheckbox';

function ShowMonitDataStructures(props) {
    const { dataStructures, setDataStructures } = useOutletContext();
    const { privilege } = useSelector((state) => state.session);
    const navigate = useNavigate();
    const { confirm } = useContext(ConfirmContext);

    // 수정 버튼 클릭 이벤트
    const onClickEditBtn = (e, selData) => {
        e.preventDefault();
        navigate(`/home/dataStructure/monitoring/edit/${selData}`);
    };

    // 추가 버튼 클릭 이벤트
    const onClickCreateBtn = (e) => {
        e.preventDefault();
        navigate('/home/dataStructure/monitoring/create');
    };

    // 삭제 버튼 클릭 이벤트
    const onClickDeleteBtn = async (e, selData) => {
        e.preventDefault();
        const selectedData = dataStructures.filter(el => el.dDsId === selData)[0];
        const result = await confirm(`${selectedData.tableName}를(을) 삭제하시겠습니까?`, '삭제', '취소');
        if (result) {
            // 삭제
            await axios.post(`${API_URL}/monitoring-manage/deleteDataStructure`, { dDsId: selData }).then(res => {
                const { success } = res.data;
                if (success) {
                    navigate(0);
                }
            })
        }
    };

    console.log(dataStructures)

    return (
        <React.Fragment>

            <div className='showMonitDataStructures'>
                <p className='path'>데이터 구조 관리<span className='below'>{'>'}</span>세부 데이터 구조</p>
                <h2 className='pageTitle'>세부 데이터 구조</h2>
                <div className='sumDsArea'>
                    <div className='dataStructureTblArea'>
                        <ul className='dataStructureTbl'>
                            <li className='row th'>
                                <ul>
                                    <li className='col tableName'>데이터 이름</li>
                                    <li className='col class'>데이터 분류</li>
                                    <li className='col indexNo'>세부 데이터 개수</li>
                                    <li className='col indexName'>세부 데이터 이름</li>
                                    <li className='col indexType'>데이터 유형</li>
                                    <li className='col indexDim'>단위</li>
                                    <li className='col isCalc'>계산 데이터 여부</li>
                                    <li className='col valView'>값 표시</li>
                                    <li className='col comment'>코멘트</li>
                                    <li className='col edit'>수정</li>
                                    <li className='col delete'>삭제</li>
                                </ul>
                            </li>
                            {
                                dataStructures.map((item, index, array) => {
                                    return (
                                        <li key={index} className='row'>
                                            <ul>
                                                <li className='col tableName'>{item.tableName}</li>
                                                <li className='col class'>{item.class}</li>
                                                <li className='col indexNo'>{item.indexNo}</li>
                                                <li className='col indexName'><ul>{
                                                    item.indexName.map((e, idx) => <li className='innerCol indexName' key={idx}>{e}</li>)
                                                }</ul></li>
                                                <li className='col indexType'><ul>{
                                                    item.indexType.map((e, idx) => <li className='innerCol indexType' key={idx}>{e}</li>)
                                                }</ul></li>
                                                <li className='col indexDim'><ul>{
                                                    item.indexDim.map((e, idx) => <li className='innerCol indexDim' key={idx}>{e}</li>)
                                                }</ul></li>
                                                <li className='col isCalc'><ul>{
                                                    item.isCalc.map((e, idx) => <li className='innerCol isCalc' key={idx}>{e ? 'O' : 'X'}</li>)
                                                }</ul></li>
                                                <li className='col valView'><ul>{
                                                    item.valView.map((valView, idx) => <li className='innerCol valView' key={idx}> <div className='divInTd'>
                                                        {/* <input type='checkbox' checked={valView} onChange={e => onCheck(e, index, idx)} /> */}

                                                        <CustomCheckbox
                                                            checked={valView}
                                                            id={`valView_${index}_${idx}`}
                                                            value={!valView}
                                                            onChange={async e => {
                                                                const copiedData = [...dataStructures];
                                                                const newValView = [...item.valView];
                                                                newValView[idx] = JSON.parse(e.target.value);
                                                                copiedData[index]["valView"] = newValView;
                                                                await axios.post(`${API_URL}/monitoring-manage/updateDetailedDataView`, { newDatas: [{dDsId: item.dDsId, valView: newValView}] }).then(res => {
                                                                    if(res.data.success) {
                                                                        setDataStructures(prev => ([...copiedData ]))
                                                                    }
                                                                });
                                                            }}
                                                            disabled={!privilege?.detailedDataView.edit}
                                                        />
                                                    </div></li>)
                                                }</ul></li>
                                                <li className='col comment'>{item.comment}</li>
                                                <li className='col edit'>
                                                    <div className='innerDiv edit'>
                                                        <button onClick={e => onClickEditBtn(e, item.dDsId)}>
                                                            <img src={editDSIcon} alt="수정" />
                                                        </button>
                                                    </div>
                                                </li>
                                                <li className='col delete'>
                                                    <div className='innerDiv delete'>
                                                        <button onClick={e => onClickDeleteBtn(e, item.dDsId)}>
                                                            <img src={deleteDSIcon} alt="삭제" />
                                                        </button>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                    );
                                })
                            }
                        </ul>
                        <div className='btnsArea'>
                            <button className='createBtn' onClick={onClickCreateBtn}>추가<img src={createIconImg} alt={"추가"} /></button>
                        </div>
                    </div>
                </div>

            </div>
        </React.Fragment>
    );
}

export default ShowMonitDataStructures;